/**
 * @generated SignedSource<<a6f5a46668ed7486aedd1f8f72b11045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoadEnrolmentsQuery$variables = {
  after?: string | null | undefined;
  excludeStatus?: string | null | undefined;
  first: number;
  instrument?: string | null | undefined;
  lessonStage?: string | null | undefined;
  orderBy?: string | null | undefined;
  pupil?: string | null | undefined;
  schoolId?: string | null | undefined;
  schoolYear?: string | null | undefined;
  searchTerm?: string | null | undefined;
  status?: string | null | undefined;
};
export type LoadEnrolmentsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LoadEnrolments_query_enrolments">;
};
export type LoadEnrolmentsQuery = {
  response: LoadEnrolmentsQuery$data;
  variables: LoadEnrolmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeStatus"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instrument"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lessonStage"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pupil"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schoolId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schoolYear"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "excludeStatus",
    "variableName": "excludeStatus"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "instrument",
    "variableName": "instrument"
  },
  {
    "kind": "Variable",
    "name": "lessonStage",
    "variableName": "lessonStage"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "pupil",
    "variableName": "pupil"
  },
  {
    "kind": "Variable",
    "name": "schoolId",
    "variableName": "schoolId"
  },
  {
    "kind": "Variable",
    "name": "schoolYear",
    "variableName": "schoolYear"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilFirstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilLastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadEnrolmentsQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "kind": "FragmentSpread",
        "name": "LoadEnrolments_query_enrolments"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadEnrolmentsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "EnrolmentNodeConnection",
        "kind": "LinkedField",
        "name": "enrolments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EnrolmentNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolNode",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "archived",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastOfferedTimestamp",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schoolYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "schoolClass",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instrument",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lessonStage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentPhoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasInvalidParentPhoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pupilNotes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminNotes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "positionInWaitingList",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EnrolmentNodeConnection",
                    "kind": "LinkedField",
                    "name": "potentialDuplicates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EnrolmentNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EnrolmentNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNodeConnection",
                    "kind": "LinkedField",
                    "name": "potentialDuplicatePupils",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accountNumber",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v11/*: any*/),
        "filters": [
          "orderBy",
          "searchTerm",
          "pupil",
          "schoolId",
          "lessonStage",
          "schoolYear",
          "instrument",
          "status",
          "excludeStatus"
        ],
        "handle": "connection",
        "key": "LoadEnrolments_query_enrolments",
        "kind": "LinkedHandle",
        "name": "enrolments"
      }
    ]
  },
  "params": {
    "cacheID": "33edc49871afb528f7fe021525a1a9ab",
    "id": null,
    "metadata": {},
    "name": "LoadEnrolmentsQuery",
    "operationKind": "query",
    "text": "query LoadEnrolmentsQuery(\n  $searchTerm: String\n  $orderBy: String\n  $schoolId: String\n  $pupil: String\n  $lessonStage: String\n  $schoolYear: String\n  $instrument: String\n  $status: String\n  $excludeStatus: String\n  $first: Int!\n  $after: String\n) {\n  ...LoadEnrolments_query_enrolments_1MkECb\n}\n\nfragment LoadEnrolments_query_enrolments_1MkECb on Query {\n  enrolments(orderBy: $orderBy, searchTerm: $searchTerm, pupil: $pupil, schoolId: $schoolId, lessonStage: $lessonStage, schoolYear: $schoolYear, instrument: $instrument, status: $status, excludeStatus: $excludeStatus, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        school {\n          id\n          name\n          archived\n        }\n        status\n        lastOfferedTimestamp\n        pupilFirstName\n        pupilLastName\n        schoolYear\n        schoolClass\n        instrument\n        lessonStage\n        parentName\n        parentEmail\n        parentPhoneNumber\n        hasInvalidParentPhoneNumber\n        pupilNotes\n        adminNotes\n        positionInWaitingList\n        potentialDuplicates {\n          edges {\n            node {\n              id\n              pupilFirstName\n              pupilLastName\n            }\n          }\n        }\n        potentialDuplicatePupils {\n          edges {\n            node {\n              id\n              accountNumber\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff8a6a75fa4eaafbdf3e7a65ec3b1023";

export default node;
